import useUserSettingsHook from "@/shared/hooks/useUserSettingsHook";
import { asArray } from "@/shared/utils/helpers";
import { OrdersLive } from "@/shared/v2/queries/interfacesV2";
import { useMemo } from "react";

const useLiveOrders = (orders: OrdersLive) => {
  const { query } = useUserSettingsHook();
  return useMemo(() => {
    return orders?.map((days) =>
      days.filter(
        (order) =>
          asArray(query?.data?.sources)?.includes(
            order.order_information.source
          ) &&
          asArray(query?.data?.delivery_methods)?.includes(
            order.order_information.delivery_method_id
          )
      )
    );
  }, [orders, query.data]);
};

export default useLiveOrders;
